/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import { Tag, Timeline } from 'antd';
import { CheckCircleFilled } from "@ant-design/icons";

import Style from './style';
import i18next from "i18next";

const CheckboxGroup = ({
  placeholder,
  config,
  item,
  inputName,
  data,
  withPlaceholder,
}) => {
  const [options, setOptions] = useState(null);
  const [allOptions, setAllOptions] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState(null);

  useEffect(() => {
    const o = (config.options || [])
      .filter(opt => ((item ? item[inputName] : data[inputName]) || []).includes(opt.value));

    setSelectedOptions(o);
    setAllOptions(config.options);
    setOptions(o.map(opt => opt.value));
  }, [config, item, inputName]);

  const optionsToMap = useMemo(() =>
    config.showOnlySelected ? selectedOptions : allOptions,
    [config, allOptions, selectedOptions]);

  if (config.yesNoTag && options) {
    const opt = options[0];
    const val = opt || false;
    return (
      <Tag color={val ? 'blue' : 'default'} style={{ width: 60, textAlign: 'center' }}>
        {val ? i18next.t('Yes') : i18next.t('No')}
      </Tag>
    );
  }

  return optionsToMap && optionsToMap.length > 0 ? (
    <Style>
      <Timeline>
        {optionsToMap.map(opt => (
          <Timeline.Item
            key={opt.label}
            className={options.includes(opt.value) ? 'filled' : 'unfilled'}
            dot={options.includes(opt.value) ? <CheckCircleFilled /> : <div className="dot-empty" />}
          >
            {opt.label}
          </Timeline.Item>
        ))}
      </Timeline>
    </Style>
  ) : placeholder(item || data, inputName, withPlaceholder);
};

export default CheckboxGroup;
